const baseURL = process.env.REACT_APP_GRAPHQL_URI;

export const getBaseURL = () => {
  const localUri = localStorage.getItem('BASE_URI');
  return localUri ?? baseURL
};

export const setBaseURL = (newURL) => {
  localStorage.setItem('BASE_URI', newURL)
};
